import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import pacote from './pacote';

// uma peca do Atendimento compartilhado ('atendimento' | 'cartao' | 'aviso') desenhada pelo pacote dentro deste div.
// O pacote recebe quem esta' logado, a URL do Atendimento (atalhos ?aba= e ?conversa=) e como navegar ate' la'
export default function Peca({ peca }){

    const loginReducer = useSelector(state => state.loginReducer);
    const history = useHistory();
    const location = useLocation();
    const elemento = useRef(null);
    const montada = useRef(null);

    const props = {
        nomeUsuario: loginReducer.dadosUsuario.nome || '',
        idFuncionario: Number(loginReducer.dadosUsuario.id),
        busca: location.pathname === '/painel/atendimento' ? location.search : '',
        navegar: destino => history.push(`/painel/atendimento${destino}`),
        // botao "Homologar chat" (so' nesta fase de testes; ver homologacao.js)
        homologar: () => history.push('/painel/atendimento/homologar')
    };

    useEffect(() => {
        montada.current = pacote.montar(elemento.current, peca, props);
        return () => montada.current.desmontar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [peca]);

    // a URL ou o login mudou: o pacote desenha de novo com os dados novos
    useEffect(() => {
        if(montada.current) montada.current.atualizar(props);
    });

    return <div ref={elemento} className={`suporte-atendimento-${peca}`} />;
}
